module.exports = __webpack_public_path__ + "static/media/building.c39bd8c4.gif";